/**
 * Created by renlaydel on 05/12/2017.
 */
import isString from 'lodash/isString';

export const addToObject = (object, field, value) => {
  object[field] = value;
};
export const objectToArray = (object) => {
  const array = [];

  if (isString(object)) {
    array.push(object);
    return array;
  }

  if (Array.isArray(object)) {
    return objectToArray(object);
  }

  for (let key in object) {
    const value = object[key];
    if (Array.isArray(value)) {
      value.forEach((obj) => {
        Object.keys(obj).forEach((key) => {
          const objValue = obj[key];
          array.push(objValue);
        });
      });
    } else {
      array.push(value);
    }
  }

  return array;
};
